<script lang="ts">
  export let text = "";
</script>

<div class="Description type-body-1">
  {@html text}
</div>

<style>
  .Description {
    hyphens: auto;
    margin-block: var(--outer-padding);
    margin-left: max(env(safe-area-inset-left), var(--outer-padding));
    margin-right: max(env(safe-area-inset-right), var(--outer-padding));
    white-space: pre-line;
  }

  .Description :global(audio),
  .Description :global(video),
  .Description :global(img) {
    display: block;
    width: 100%;
  }
</style>
